// extracted by mini-css-extract-plugin
module.exports = {"toggle":"uIdtG","menu":"_2B6Iu"};